<div class="page-content page-fill">
  @if (batches) {
    <div class="grid-fill reconciliation-data-grid" style="max-width: 95%">
      <dx-data-grid
        #dataGrid
        [dataSource]="batches"
        keyExpr="id"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        >
        <dxi-column dataField="batchDate" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="batchName" cellTemplate="nameTemplate" width="225">
          <div *dxTemplate="let d of 'nameTemplate'">
            <a [routerLink]="'/giving/batches/' + d.data.batchId">{{ d.value || '(blank)' }}</a>
          </div>
        </dxi-column>
        <dxi-column dataField="batchStatus" caption="Status" width="100"></dxi-column>
        <dxi-column dataField="batchAccountQB" caption="QB Account" width="100"></dxi-column>
        <dxi-column dataField="batchAccountClassis" caption="Classis Account" width="100"></dxi-column>
        <dxi-column dataField="batchAccountName" caption="Account Name"></dxi-column>
        <dxi-column dataField="batchNote" caption="Batch Note"></dxi-column>
        <dxi-column dataField="envelopeNumber" caption="Envelope" width="75"></dxi-column>
        <dxi-column dataField="contributionType" caption="Type" width="90"></dxi-column>
        <dxi-column
          dataField="amount"
          dataTye="number"
          [format]="{ type: 'currency', precision: 2 }"
          width="125"
          cssClass="align-right-pad"
        ></dxi-column>
        <dxi-column dataField="contributionAccount" caption="Contribution Account"></dxi-column>
        <dxi-column dataField="note" caption="Contribution Note"></dxi-column>
        <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
        <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="reconciliation-list-grid"></dxo-state-storing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="multiple" showCheckBoxesMode="true"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (batches) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
              @if (selectedAmount) {
                <strong class="ms-4">{{ 'Selected Amount: ' }}{{ selectedAmount | currency }}</strong>
              }
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  }
</div>
